module.exports = __webpack_public_path__ + "img/fin.2649533e.svg";